import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { FaqRoutes } from "./Constants/routes";

const FAQ = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {FaqRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/faq" />
      </Switch>
    </>
  );
};

export default FAQ;
